module.exports = __webpack_public_path__ + "static/media/contact.225a865f.PNG";